import { type MenuItem, type RadioItem } from '@lighthouse/shared'

import type { TemplateGroup } from '@/atoms/application/type'

export type PageItemAction = 'DELETE' | 'RENAME' | 'HOME' | 'COPY' | 'COPY_LINK' | 'CUSTOM_ROUTE'

export const menuOperationItems: MenuItem<PageItemAction>[] = [
    {
        section: '',
        items: [
            {
                name: '设为主页',
                icon: 'Home',
                hotkey: '',
                action: 'HOME'
            },
            {
                name: '自定义页面路径',
                icon: 'PropertyLink',
                hotkey: '',
                action: 'CUSTOM_ROUTE'
            },
            {
                name: '重命名',
                icon: 'PencilSimple',
                hotkey: '',
                action: 'RENAME'
            },
            // {
            //     name: '复制页面链接',
            //     icon: 'LinkSimple',
            //     hotkey: '',
            //     action: 'COPY_LINK'
            // },
            {
                name: '复制',
                icon: 'Duplicate',
                hotkey: '',
                action: 'COPY'
            },
            {
                name: '删除',
                icon: 'Trash',
                hotkey: '',
                action: 'DELETE'
            }
        ]
    }
]

export const PAGE_FILTER_OPTIONS = [
    {
        label: '所有页面',
        value: 'all',
        group: 'system'
    },
    {
        label: '公开页面',
        value: 'public',
        group: 'system'
    },
    {
        label: '登录后可见页面',
        value: 'login',
        group: 'system'
    }
]

export const BLOCK_OPTIONS = [
    {
        label: '基础',
        value: 'base'
    },
    {
        label: '模板',
        value: 'template'
    },
    {
        label: '同步',
        value: 'sync'
    }
]

export const TEMPLATE_BLOCK_TYPE_NAME: Record<TemplateGroup, string> = {
    MENU: '菜单',
    NAVIGATION: '导航栏',
    MODULE: '模块',
    BOTTOM: '底部栏',
    CUSTOM_VIEW: '自定义视图'
}
